import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import { MUIButton } from 'components/common/MUIButton'
import { useEmbedCrm } from 'utils/embedSession/useEmbedCrm'
import { useTranslation } from 'react-i18next'

/** Props for the {@link EmbedCatalogueError} component. */
interface EmbedCatalogueErrorProps {
  /** Re-fires the catalogue load. Omitted, the screen is terminal (the broker has to reopen the property). */
  onRetry?: () => void
}

/**
 * Full-screen embed state shown when the product catalogue settled with nothing to offer (ISSUE-3396): a failed
 * load, or a 200 with no products for this account. Without it the area gate rendered an empty slider (or the
 * step stayed blank) and nothing told the broker why.
 */
export const EmbedCatalogueError: FC<EmbedCatalogueErrorProps> = ({ onRetry }) => {
  const { t } = useTranslation(['embed'])
  const { crmName } = useEmbedCrm()

  return (
    <Stack spacing={1} alignItems='center' justifyContent='center' sx={{ height: '100%', p: 4, textAlign: 'center' }}>
      <Typography variant='h6'>{t('catalogue_error.title')}</Typography>
      <Typography variant='body2' color='text.secondary'>{t('catalogue_error.message_crm', { crm: crmName })}</Typography>
      {onRetry &&
        <MUIButton onClick={onRetry} sx={{ mt: 2 }}>{t('catalogue_error.retry')}</MUIButton>
      }
    </Stack>
  )
}

export default EmbedCatalogueError
